import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import { applyProposalOutcomes } from "./proposalCache.utils";

const { estimateChatControllerRejectProposals } = getRebuildAPI();

export function useRejectProposalsMutation(estimateId: string, chatId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (proposalIds: string[]) => estimateChatControllerRejectProposals(estimateId, chatId, { proposalIds }),
    onSuccess: ({ outcomes }) => applyProposalOutcomes(queryClient, estimateId, chatId, outcomes),
    onError: (error) => {
      console.error("Reject proposals error:", error);
    },
  });
}
